import React from 'react';
import { Display, Heading, Label, Body } from '../components/Typography';
import Button from '../components/Button';

const ProgrammeEveryday = () => {
  return (
    <article className="w-full bg-epoq-paper">
      {/* Header - Distinctive layout compared to Leadership page */}
      <header className="pt-20 pb-24 px-6 lg:px-12 bg-epoq-blue text-epoq-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-9">
            <Label className="text-epoq-lime mb-8 block">Programme 02</Label>
            <Display className="mb-12 text-epoq-paper">Generative AI for <br/><span className="italic opacity-90">Everyday Knowledge Work</span></Display>
          </div>
          <div className="lg:col-span-3 pb-4">
             <div className="w-full h-px bg-epoq-lime mb-6"></div>
             <p className="font-sans text-sm opacity-80 uppercase tracking-widest">Practical Application</p>
          </div>
        </div>
      </header>

      <div className="bg-epoq-lime py-12 px-6 lg:px-12 text-epoq-blue font-serif text-2xl lg:text-3xl text-center leading-snug">
        Many professionals are already experimenting with generative AI. <br className="hidden md:block"/>
        The challenge is turning scattered use into safe, repeatable and valuable working practices.
      </div>

      {/* Details Grid */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16">
          
          <div className="lg:col-span-7 space-y-24">
            
            <div>
              <Body large className="mb-12 text-xl font-medium">
                This programme helps participants use generative AI with better structure, judgement and quality control in the tasks they already perform.
              </Body>
              
              <Heading className="mb-8 text-3xl">Learning Outcomes</Heading>
              <p className="mb-6 opacity-60 italic font-serif">Participants should leave able to:</p>
              <ul className="space-y-4 text-lg list-disc list-inside marker:text-epoq-coral">
                <li>Understand what generative AI can and cannot reliably do</li>
                <li>Structure prompts and tasks more effectively</li>
                <li>Improve documents, research, analysis and communication</li>
                <li>Use AI as part of a repeatable workflow</li>
                <li>Check accuracy, quality and bias</li>
                <li>Recognise privacy, data and intellectual property risks</li>
                <li>Build a practical personal AI work kit</li>
              </ul>
            </div>

            <div>
              <Heading className="mb-10 text-3xl">Programme Structure</Heading>
              <div className="grid gap-4">
                {[
                  'How generative AI works in professional practice',
                  'From prompting to structured task design',
                  'Documents, communication, research and analysis',
                  'Quality control and human judgement',
                  'Safe and responsible use',
                  'Building your personal AI work kit'
                ].map((item, i) => (
                  <div key={i} className="bg-white p-6 border border-epoq-blue/10 flex items-center gap-4 hover:border-epoq-lime transition-colors">
                    <span className="font-sans font-bold text-epoq-blue/40 text-sm">0{i+1}</span>
                    <span className="font-medium text-lg">{item}</span>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* Right Column (Sidebar) */}
          <div className="lg:col-span-4 lg:col-start-9 space-y-16">
            
            <div className="border-t-4 border-epoq-blue pt-6">
              <Label className="mb-6 block">Target Participants</Label>
              <div className="flex flex-wrap gap-2 font-sans text-sm">
                {['Knowledge workers', 'Project managers', 'Consultants', 'Administrative teams', 'Marketing & sales', 'Internal specialists', 'Support functions', 'Team leaders'].map((item, i) => (
                  <span key={i} className="bg-epoq-blue/5 px-3 py-1 rounded-sm">{item}</span>
                ))}
              </div>
            </div>

            <div className="border-t border-epoq-blue/20 pt-6">
              <Label className="mb-6 block">Practical Work</Label>
              <ul className="space-y-2 opacity-80 text-sm">
                <li>Document development</li>
                <li>Meeting preparation & follow-up</li>
                <li>Research & synthesis</li>
                <li>Analysis & comparison</li>
                <li>Communication drafts</li>
                <li>Workflow improvement</li>
              </ul>
            </div>

            <div className="border-t border-epoq-blue/20 pt-6">
              <Label className="mb-6 block">Format</Label>
              <p className="opacity-90 mb-2 font-medium">One day in person or live online.</p>
              <p className="opacity-70 text-sm italic">A short follow-up session may be added after two or three weeks.</p>
            </div>

            <div className="pt-8">
              <Button to="/contact" variant="primary" className="w-full mb-4">Register your interest</Button>
              <Button to="/contact" variant="outline" className="w-full">Discuss a team programme</Button>
            </div>

          </div>
        </div>
      </section>
    </article>
  );
};

export default ProgrammeEveryday;